import React from 'react';
import classnames from 'classnames';
import s from './FeedLayout.scss';
var FeedLayout = function (_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("div", { className: classnames(s['root'], className) },
        React.createElement("div", { className: s['feed-wrapper'] }, children)));
};
FeedLayout.displayName = 'FeedLayout';
export default FeedLayout;
//# sourceMappingURL=FeedLayout.js.map